import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "@blocknote/mantine/style.css";
import "./lib/i18n";
import { initializeSentry } from "./lib/sentry";
import { applyRedirectWorkspaceFromUrl } from "./utils/redirect-workspace";

// Initialize Sentry before rendering the app
initializeSentry();

// Honor `?redirect_workspace_id=<id>` from external deep-links (Slack / email)
// before the app renders, so workspace-scoped queries boot in the right workspace.
applyRedirectWorkspaceFromUrl();

// Windows (and other non-macOS desktops) render classic, always-visible
// scrollbars that are much harder to grab than macOS overlay bars. Tag the
// document so CSS can widen them (see `.os-win` in index.css).
(function tagPlatform() {
  const ua = navigator.userAgent;
  const isMac = /Mac|iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);
  if (!isMac && !isAndroid) document.documentElement.classList.add("os-win");
})();

// Handle chunk load errors by reloading the page once
// This fixes the issue where old cached HTML tries to load non-existent chunks after deployment
window.addEventListener('error', (event) => {
  const isChunkLoadError =
    event.message?.includes('Failed to fetch dynamically imported module') ||
    event.message?.includes('Importing a module script failed') ||
    event.message?.includes('Failed to load resource');

  if (isChunkLoadError && !sessionStorage.getItem('chunk_failed')) {
    sessionStorage.setItem('chunk_failed', 'true');
    window.location.reload();
  }
});

// Initialize Intercom widget (hidden by default, shown via window.Intercom("show"))
(function initIntercom() {
  const w = window as any;
  w.Intercom = w.Intercom || function (...args: any[]) {
    (w.Intercom.q = w.Intercom.q || []).push(args);
  };
  w.Intercom("boot", { app_id: "tupf1c4d", hide_default_launcher: true });
  const s = document.createElement("script");
  s.src = "https://widget.intercom.io/widget/tupf1c4d";
  s.async = true;
  document.head.appendChild(s);
})();

createRoot(document.getElementById("root")!).render(<App />);
